// This file is generated automatically
// Don't edit this file directly

import { call, toParams } from './utils'

export let api_origin = '/api'

// GET /api/assetsBrowser/getScenes
export function getScenes(input: GetScenesInput): Promise<GetScenesOutput & { error?: string }> {
  return call('GET', api_origin + `/assetsBrowser/getScenes?` + toParams(input.query))
}
export type GetScenesInput = {
  query: {
    is_ready_only: boolean
    is_bookmarked: boolean
    is_user_created: boolean
    page_number: number
    items_per_page: number
    search_keywords: string
    skybox_style: string
    suno_style: string
  }
}
export type GetScenesOutput = {
  scenes: Array<{
    id: number
    image_prompt: string
    music_prompt: null | string
    image_url: null | string
    music_url: null | string
    image_style: string
    music_style: null | string
    submit_time: number
  }>
  page_number: number
  maxPage: number
}

// GET /api/assetsBrowser/getSceneCount
export function getSceneStyleCount(input: GetSceneStyleCountInput): Promise<GetSceneStyleCountOutput & { error?: string }> {
  return call('GET', api_origin + `/assetsBrowser/getSceneCount?` + toParams(input.query))
}
export type GetSceneStyleCountInput = {
  query: {
    is_bookmarked: boolean
    is_user_created: boolean
    search_keywords: string
    scene_style: null | string
    music_style: null | string
  }
}
export type GetSceneStyleCountOutput = {
  sceneStyleCounter: Record<string,number>
  musicStyleCounter: Record<string,number>
}

// GET /api/assetsBrowser/getObjects
export function getObjects(input: GetObjectsInput): Promise<GetObjectsOutput & { error?: string }> {
  return call('GET', api_origin + `/assetsBrowser/getObjects?` + toParams(input.query))
}
export type GetObjectsInput = {
  query: {
    is_bookmarked: boolean
    is_user_created: boolean
    page_number: number
    items_per_page: number
    search_keywords: string
    tripo_style: string
  }
}
export type GetObjectsOutput = {
  objects: Array<{
    id: number
    model_type: string
    prompt: string
    style: string
    preview_url: null | string
    model_url: null | string
  }>
  page_number: number
  maxPage: number
}

// GET /api/assetsBrowser/getObjectCount
export function getObjectStyleCount(input: GetObjectStyleCountInput): Promise<GetObjectStyleCountOutput & { error?: string }> {
  return call('GET', api_origin + `/assetsBrowser/getObjectCount?` + toParams(input.query))
}
export type GetObjectStyleCountInput = {
  query: {
    is_bookmarked: boolean
    is_user_created: boolean
    search_keywords: string
  }
}
export type GetObjectStyleCountOutput = {
  styleCounter: Record<string,number>
}
